import { Component, Input, ViewEncapsulation, ViewChild, SimpleChanges, Output, EventEmitter} from '@angular/core';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
 
@Component({
  selector: 'select-all-option',
  templateUrl: './select-all.option.html',
  styleUrls: ['./select-all.option.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectAllOption  {

  value: any
  @Input('value') set _value(value: any)
  {
    setTimeout( ()=>{this.value = value; this.checkStatus()} ,0)    
  } 

  @Input() values = [];
  @Input() text = 'Seleziona tutti'; 
 
  checkbox: MatCheckbox

  @Output () setter: EventEmitter<any> = new EventEmitter<any>()

  @ViewChild('checkbox') set _checkbox(checkbox: MatCheckbox){
    setTimeout( ()=>{this.checkbox = checkbox; this.checkStatus()} ,0)    
  }

  ngOnChanges(changeRecord: SimpleChanges) {

    if(changeRecord && changeRecord.value && changeRecord.value.currentValue != changeRecord.value.previousValue)
      this.checkStatus()

  } 

  checkStatus()
  {
    if(!this.checkbox) return
    this.checkbox.checked       = this.isChecked()
    this.checkbox.indeterminate = this.isIndeterminate()
  }

  isChecked(): boolean {
    return      this.value 
            &&  this.values
            &&  this.values.length
            &&  this.value.length
            &&  this.value.length === this.values.length;
  }
 
  isIndeterminate(): boolean {
    return      this.value 
            &&  this.values
            &&  this.values.length 
            &&  this.value.length
            &&  this.value.length < this.values.length;
  }
 
  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.setter.emit("all")
    } else {
      this.setter.emit("single")
    }
  }
}
